/**
 * @module constants
 */

export default {
  BROWSER: 'BROWSER',
  NLE: 'NLE',
  NCS: 'NCS'
};



// WEBPACK FOOTER //
// ./app/constants/appRunMode.js